"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LawListGenerator = exports.LawInfo = void 0;
const lawNum_1 = require("../law/lawNum");
class LawInfo {
    /** この法令が参照している法令の法令番号の一覧 */
    ReferencingLawNums = new Set();
    /** この法令を参照している法令の法令番号の一覧 */
    ReferencedLawNums = new Set();
    /** 法令ID */
    LawID;
    /** 法令番号 */
    LawNum;
    /** 法令名 */
    LawTitle;
    /** 施行済みかどうか */
    Enforced;
    Path;
    XmlName;
    constructor(LawID, LawNum, LawTitle, Enforced, Path, XmlName) {
        this.LawID = LawID;
        this.LawNum = LawNum;
        this.LawTitle = LawTitle;
        this.Enforced = Enforced;
        this.Path = Path;
        this.XmlName = XmlName;
    }
    toTuple() {
        return [
            this.LawID,
            this.LawNum,
            this.LawTitle,
            this.Enforced,
            this.Path,
            this.XmlName,
            Array.from(this.ReferencingLawNums),
            Array.from(this.ReferencedLawNums),
        ];
    }
    toBaseLawInfo() {
        return {
            LawID: this.LawID,
            LawNum: this.LawNum,
            LawTitle: this.LawTitle,
            Enforced: this.Enforced,
            Path: this.Path,
            XmlName: this.XmlName,
        };
    }
    static fromBaseLawInfo(baseLawInfo) {
        const { LawID, LawNum, LawTitle, Enforced, Path, XmlName, } = baseLawInfo;
        const lawInfo = new LawInfo(LawID, LawNum, LawTitle, Enforced, Path, XmlName);
        return lawInfo;
    }
    static getHeader() {
        return [
            "LawID",
            "LawNum",
            "LawTitle",
            "Enforced",
            "Path",
            "XmlName",
            "ReferencingLawNums",
            "ReferencedLawNums",
        ];
    }
    static fromTuple(tuple) {
        const [LawID, LawNum, LawTitle, Enforced, Path, XmlName, ReferencingLawNums, ReferencedLawNums,] = tuple;
        const lawInfo = new LawInfo(LawID, LawNum, LawTitle, Enforced, Path, XmlName);
        for (const v of ReferencingLawNums)
            lawInfo.ReferencingLawNums.add(v);
        for (const v of ReferencedLawNums)
            lawInfo.ReferencedLawNums.add(v);
        return lawInfo;
    }
    addReferencingLawNums(xml) {
        for (const m of xml.match(new RegExp(lawNum_1.ptnLawNumLike, "g")) || []) {
            if (m !== this.LawNum)
                this.ReferencingLawNums.add(m);
        }
    }
}
exports.LawInfo = LawInfo;
class LawListGenerator {
    lawInfos = [];
    lawInfoMap = new Map();
    add(lawInfo) {
        this.lawInfos.push(lawInfo);
        if (!this.lawInfoMap.has(lawInfo.LawNum))
            this.lawInfoMap.set(lawInfo.LawNum, []);
        this.lawInfoMap.get(lawInfo.LawNum)?.push(lawInfo);
    }
    setReferences() {
        for (const referencingLawInfo of this.lawInfos) {
            for (const lawnum of Array.from(referencingLawInfo.ReferencingLawNums)) {
                const referencedLawInfos = this.lawInfoMap.get(lawnum);
                if (referencedLawInfos) {
                    for (const referencedLawInfo of referencedLawInfos) {
                        referencedLawInfo.ReferencedLawNums.add(referencingLawInfo.LawNum);
                    }
                }
                else {
                    referencingLawInfo.ReferencingLawNums.delete(lawnum);
                }
            }
        }
    }
    getList() {
        return {
            header: LawInfo.getHeader(),
            body: this.lawInfos.map(lawinfo => lawinfo.toTuple()),
        };
    }
}
exports.LawListGenerator = LawListGenerator;
//# sourceMappingURL=lawinfo.js.map